import React, { useLayoutEffect } from 'react';

import { useParams, useLocation, useNavigate } from 'react-router-dom';

import TetriaryNav from '../../TetriaryNav';
import Details from './Details';
import BankStatementCollections from './BankStatementCollections';

export default function Underwriting({ bankStatementCollections, refetch }) {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const hasBankStatementCollections =
    bankStatementCollections && bankStatementCollections.length > 0;

  const navLinks = [
    {
      title: 'Details',
      url: `/loan-files/${id}/underwriting/details`,
    },
  ];

  if (hasBankStatementCollections) {
    navLinks.push({
      title: 'Bank Statements',
      url: `/loan-files/${id}/underwriting/bank-statements`,
    });
  }

  // Redirect to the first tab if no tab is selected
  useLayoutEffect(() => {
    if (location.pathname === `/loan-files/${id}/underwriting`) {
      navigate(`/loan-files/${id}/underwriting/details`, { replace: true });
    }
  }, [location.pathname, id, navigate]);

  return (
    <div className="h-full bg-white">
      <div className="pt-5 px-7 md:px-10 mb-4">
        <TetriaryNav navLinks={navLinks} />
      </div>
      {location.pathname === `/loan-files/${id}/underwriting/details` && (
        <Details />
      )}
      {location.pathname ===
        `/loan-files/${id}/underwriting/bank-statements` && (
        <BankStatementCollections
          bankStatementCollections={bankStatementCollections}
          refetch={refetch}
        />
      )}
    </div>
  );
}
